import { COUPON, PROMO } from 'contexts/CruiseSearchContext/constants';

export const getPromoCodeApplied = ({ qualifiers, query, targetedOffers }) => {
	const promoCodeApplied =
		targetedOffers?.find((x) => {
			if (qualifiers[COUPON] && query[PROMO]) {
				return x.couponCode === qualifiers[COUPON]?.split(',')?.[0] && x.code === query[PROMO];
			} else {
				if (qualifiers[COUPON]) {
					return x.couponCode === qualifiers[COUPON]?.split(',')?.[0];
				}

				if (query[PROMO]) {
					return x.code === query[PROMO];
				}
			}

			return false;
		}) || {};

	return promoCodeApplied;
};
